/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Subject_PlaceholderInputs */

const en_form_subject_placeholder = /** @type {(inputs: Form_Subject_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject`)
};

const ar_form_subject_placeholder = /** @type {(inputs: Form_Subject_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الموضوع`)
};

const bn_form_subject_placeholder = /** @type {(inputs: Form_Subject_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিষয়`)
};

const de_form_subject_placeholder = /** @type {(inputs: Form_Subject_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betreff`)
};

const es_form_subject_placeholder = /** @type {(inputs: Form_Subject_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asunto`)
};

const fr_form_subject_placeholder = /** @type {(inputs: Form_Subject_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objet`)
};

const pt_form_subject_placeholder = /** @type {(inputs: Form_Subject_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assunto`)
};

const zh_form_subject_placeholder = /** @type {(inputs: Form_Subject_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主题`)
};

const tr_form_subject_placeholder = /** @type {(inputs: Form_Subject_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konu`)
};

const ru_form_subject_placeholder = /** @type {(inputs: Form_Subject_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тема`)
};

const pl_form_subject_placeholder = /** @type {(inputs: Form_Subject_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temat`)
};

/**
* | output |
* | --- |
* | "Subject" |
*
* @param {Form_Subject_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_subject_placeholder = /** @type {((inputs?: Form_Subject_PlaceholderInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Subject_PlaceholderInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_subject_placeholder(inputs)
	if (locale === "bn") return bn_form_subject_placeholder(inputs)
	if (locale === "de") return de_form_subject_placeholder(inputs)
	if (locale === "es") return es_form_subject_placeholder(inputs)
	if (locale === "fr") return fr_form_subject_placeholder(inputs)
	if (locale === "pt") return pt_form_subject_placeholder(inputs)
	if (locale === "zh") return zh_form_subject_placeholder(inputs)
	if (locale === "tr") return tr_form_subject_placeholder(inputs)
	if (locale === "ru") return ru_form_subject_placeholder(inputs)
	if (locale === "pl") return pl_form_subject_placeholder(inputs)
	return en_form_subject_placeholder(inputs)
});